import React from "react";
import { postSendNotificationTEST } from "src/requests/notifications/requests";
import AdminOnly from "../../../atoms/AdminOnly";
import { DesktopOnly } from "../../../atoms/ViewportRestrictor";
import { RightSectionContainer } from "../styles";
import Account from "./Account";
import Administration from "./Administration";
import Notifications from "./Notifications";

export type RightSectionProps = {
  hideLogin?: boolean;
};

const RightSection = ({ hideLogin = false }: RightSectionProps) => (
  <RightSectionContainer id="nav-user-section">
    <Notifications />
    <AdminOnly>
      <DesktopOnly>
        <Administration />
      </DesktopOnly>
    </AdminOnly>
    {!hideLogin && <Account />}
  </RightSectionContainer>
);

export default RightSection;
